import * as React from 'react';

import type { ImageCandidate } from 'types';

// this is used by DiscoveryContentResults in order
// to change items prop dynamically for GalleryModal
export default React.createContext<Array<ImageCandidate>>([]);
